export default __webpack_public_path__ + "static/media/otomi.c053e217.svg";